import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

interface ISelectMenuComponentProps {
  id: string;
  label: string;
  value: string | null | undefined;
  onChange: (event: any) => void;
  native?: boolean;
  children: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      borderRadius: '10px',
    },
    label: {
      color: theme.palette.primary.main,
    },
  }),
);

export default function SelectMenuComponent(props: ISelectMenuComponentProps) {
  const { id, label, value, onChange, native = true, children } = props;
  const classes = useStyles(baseTheme);

  return (
    <>
      <InputLabel htmlFor={`filled-${id}`} className={classes.label}>{label}</InputLabel>
      <Select
        native={native}
        value={value}
        onChange={onChange}
        inputProps={{
          name: label,
          id: `filled-${id}`,
        }}
        className={classes.input}
      >
        {children}
      </Select>
    </>
  );
}
